<form
  [formGroup]="buyerForm"
  class="flex flex-col gap-8"
  *transloco="let t; prefix: 'shared.checkout.step-buyer-info'"
>
  <ng-container [formGroupName]="'mainForm'">
<!--     <h3 class="text-xl text-black">{{orderData?.total !== 0 ? 'Πληροφορίες χρέωσης' : 'Στοιχεία Πελάτη'}}</h3> -->
    @if (orderData?.total !== 0) {
      <div
        class="p-1 border-full border border-gray-500 bg-gray-50 flex flex-row rounded-full mb-8"
      >
        <button
          class="tab-pill flex-1 justify-center"
          type="button"
          [ngClass]="{ active: proofOfPayment == ProofOfPaymentEnum.Receipt }"
          (click)="onProofOfPaymentChange(ProofOfPaymentEnum.Receipt)"
        >
          {{
            "shared.enum.proofOfPayment." + ProofOfPaymentEnum.Receipt | transloco
          }}
        </button>
        <button
          class="tab-pill flex-1 justify-center"
          type="button"
          [ngClass]="{ active: proofOfPayment == ProofOfPaymentEnum.Invoice }"
          (click)="onProofOfPaymentChange(ProofOfPaymentEnum.Invoice)"
        >
          {{
            "shared.enum.proofOfPayment." + ProofOfPaymentEnum.Invoice | transloco
          }}
        </button>
      </div>
    }

    <div class="grid lg:gap-x-8 gap-8 lg:grid-cols-2 grid-cols-1">
      <div class="flex flex-col lg:gap-6 gap-8">
        <fieldset class="flex flex-col gap-2 group/input">
          <label
            [ngClass]="{ 'text-red': controlHasError('mainForm.fullName') }"
            class="font-semibold text-gray-950 group-disabled:text-gray-300"
            >{{ t("labels.fullName") }}<span class="text-error"> *</span></label
          >
          <input
            [formControlName]="'fullName'"
            class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          />
          <span
            *ngIf="controlHasError('mainForm.fullName')"
            class="text-error"
            >{{ "shared.error.requiredField" | transloco }}</span
          >
        </fieldset>
        <fieldset class="flex flex-col gap-2 group/input">
          <label
            [ngClass]="{ 'text-red': controlHasError('mainForm.address') }"
            class="font-semibold text-gray-950 group-disabled:text-gray-300"
            >{{ t("labels.address") }}<span class="text-error"> *</span></label
          >
          <input
            [formControlName]="'address'"
            class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          />
          <span
            *ngIf="controlHasError('mainForm.address')"
            class="text-error"
            >{{ "shared.error.requiredField" | transloco }}</span
          >
        </fieldset>
        <fieldset class="flex flex-col gap-2 group/input">
          <label
            [ngClass]="{ 'text-red': controlHasError('mainForm.city') }"
            class="font-semibold text-gray-950 group-disabled:text-gray-300"
            >{{ t("labels.city") }}<span class="text-error"> *</span></label
          >
          <input
            [formControlName]="'city'"
            class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          />
          <span *ngIf="controlHasError('mainForm.city')" class="text-error">{{
            "shared.error.requiredField" | transloco
          }}</span>
        </fieldset>
        <fieldset class="flex flex-col gap-2 group/input">
          <label
            [ngClass]="{ 'text-red': controlHasError('mainForm.landLine') }"
            class="font-semibold text-gray-950 group-disabled:text-gray-300"
            >{{ t("labels.landLine") }}</label
          >
          <input
            [formControlName]="'landLine'"
            type="text"
            [mask]="'9999999999'"
            class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          />
          <span
            *ngIf="controlHasError('mainForm.landLine')"
            class="text-error"
            >{{ "shared.error.requiredField" | transloco }}</span
          >
        </fieldset>
      </div>

      <div class="flex-1 flex flex-col lg:gap-6 gap-8">
        <fieldset class="flex flex-col gap-2 group/input">
          <label
            [ngClass]="{ 'text-red': controlHasError('mainForm.email') }"
            class="font-semibold text-gray-950 group-disabled:text-gray-300"
            >{{ t("labels.email") }}<span class="text-error"> *</span></label
          >
          <input
            [formControlName]="'email'"
            class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          />
          <span *ngIf="controlHasError('mainForm.email')" class="text-error">{{
            "shared.error.requiredField" | transloco
          }}</span>
        </fieldset>

        <fieldset class="flex flex-col gap-2 group/input">
          <label
            [ngClass]="{ 'text-red': controlHasError('mainForm.zipCode') }"
            class="font-semibold text-gray-950 group-disabled:text-gray-300"
            >{{ t("labels.zipCode") }}<span class="text-error"> *</span></label
          >
          <input
            [formControlName]="'zipCode'"
            [mask]="'999999'"
            class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          />
          <span
            *ngIf="controlHasError('mainForm.zipCode')"
            class="text-error"
            >{{ "shared.error.invalidField" | transloco }}</span
          >
        </fieldset>
        <fieldset class="flex flex-col gap-2 group/input">
          <label
            [ngClass]="{ 'text-red': controlHasError('mainForm.mobilePhone') }"
            class="font-semibold text-gray-950 group-disabled:text-gray-300"
            >{{ t("labels.mobilePhone") }}
            <span class="text-error">*</span></label
          >
          <div
            class="flex text-gray-500 rounded-full border border-gray-300 py-3 px-4 bg-white group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          >
          <app-county-code-dropdown class="content-center" [countryCode]="countryCode" (DropdownSelected)="onPickCountry($event)"></app-county-code-dropdown>
          {{countryCode}}
          <input
            [formControlName]="'mobilePhone'"
            type="text"
            [mask]="'9999999999'"
            class="bg-white outline-none ml-2 flex-1 group-hover/input:bg-white transition-colors duration-300"
          />
          </div>
          <span
            *ngIf="controlHasError('mainForm.mobilePhone')"
            class="text-error"
            >{{ "shared.error.invalidField" | transloco }}</span
          >
        </fieldset>
      </div>
    </div>
    <div [ngClass]="{'order-last' : proofOfPayment === ProofOfPaymentEnum.Invoice}">
      <div class="w-full p-4 border-gray-400 border rounded mb-3">
        <label
          for="checkbox-selector-transaction-terms"
          class="checkbox-selector w-full"
        >
          <input
          [formControlName]="'paymentsTermsAccepted'"
          (change)="onTermsChange()"
            type="checkbox"
            class="hidden"
            id="checkbox-selector-transaction-terms"
            name="checkbox-selector-term"
          />
          <div class="checkbox-selector-content">
            <span class="checkbox-selector-text text-black ml-4 font-normal">
              {{ t("labels.readAndAccept") }}
              <a [localizedRouterLink]="['/terms-and-conditions']" [queryParams]="{ documentType: 'terms-and-conditions' }"
                target="_blank"
                class="text-primary cursor-pointer font-bold"
                >{{ t("labels.termsOfUseAndTransactions") }}</a
              >
            </span>
          </div>
        </label>
      </div>
      <div class="w-full p-4 border-gray-400 border rounded mb-12">
        <label for="checkbox-selector-terms" class="checkbox-selector w-full">
          <input
          [formControlName]="'serviceTermsAccepted'"
          (change)="onTermsChange()"
            type="checkbox"
            class="hidden"
            id="checkbox-selector-terms"
            name="checkbox-selector-term"
          />
          <div class="checkbox-selector-content">
            <span class="checkbox-selector-text text-black ml-4 font-normal">
              {{ t("labels.readAndAccept") }}
              <a [localizedRouterLink]="['/terms-and-conditions']" [queryParams]="{ documentType: termsDocumentType }" target="_blank"
                class="text-primary cursor-pointer font-bold"
                >{{ t("labels.serviceTermsAndConditions") }}</a
              >
            </span>
          </div>
        </label>
      </div>
    </div>
    <span
      *ngIf="controlHasError('mainForm.termsConditionsAccepted')"
      class="text-error"
      >{{ t("acceptTncError") }}</span
    >
  </ng-container>
  <ng-container *ngIf="proofOfPayment === ProofOfPaymentEnum.Invoice">
    <ng-container [formGroupName]="'invoiceSubForm'">
      <fieldset class="flex flex-col gap-2 group/input">
        <label
          [ngClass]="{
            'text-red': controlHasError('invoiceSubForm.taxNumber')
          }"
          class="font-semibold text-gray-950 group-disabled:text-gray-300"
          >{{ t("labels.taxNumber") }}<span class="text-error"> *</span></label
        >
        <input
          [formControlName]="'taxNumber'"
          class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
        />
      </fieldset>
      <fieldset class="flex flex-col gap-2 group/input">
        <label
          [ngClass]="{
            'text-red': controlHasError('invoiceSubForm.companyName')
          }"
          class="font-semibold text-gray-950 group-disabled:text-gray-300"
          >{{ t("labels.companyName")
          }}<span class="text-error"> *</span></label
        >
        <input
          [formControlName]="'companyName'"
          class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
        />
      </fieldset>
      <fieldset class="flex flex-col gap-2 group/input">
        <label
          [ngClass]="{
            'text-red': controlHasError('invoiceSubForm.taxOffice')
          }"
          class="font-semibold text-gray-950 group-disabled:text-gray-300"
          >{{ t("labels.taxOffice") }}<span class="text-error"> *</span></label
        >
        <input
          [formControlName]="'taxOffice'"
          class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
        />
      </fieldset>
      <fieldset class="flex flex-col gap-2 group/input">
        <label
          [ngClass]="{
            'text-red': controlHasError('invoiceSubForm.profession')
          }"
          class="font-semibold text-gray-950 group-disabled:text-gray-300"
          >{{ t("labels.profession") }}<span class="text-error"> *</span></label
        >
        <input
          [formControlName]="'profession'"
          class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
        />
      </fieldset>
    </ng-container>
  </ng-container>
</form>
